exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-single---woh9Q{overflow:hidden}.product-img---GrgRi{height:185px}.product-img-img---7BkL8{max-height:180px}", ""]);

// exports
exports.locals = {
	"product-single": "product-single---woh9Q",
	"product-img": "product-img---GrgRi",
	"product-img-img": "product-img-img---7BkL8"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/directives/product/item/style.scss
// module id = 361
// module chunks = 0